import { render, staticRenderFns } from "./ModernRadioTabs.vue?vue&type=template&id=007515c9&"
import script from "./ModernRadioTabs.vue?vue&type=script&lang=js&"
export * from "./ModernRadioTabs.vue?vue&type=script&lang=js&"
import style0 from "./ModernRadioTabs.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports